import { useEffect } from 'react'
import { PROOF_STEPS, ANCHOR_FAIL } from './proofSteps.js'

/**
 * Preloads proof-step assets on mount: still photos + the video shots' poster
 * frames (as Images), and warms the video clips (as detached <video> elements
 * with preload="auto"). Fire-and-forget — the elements are never attached, so the
 * browser just caches the fetched resources and there is nothing to clean up.
 */
export const usePreloadProofPhotos = (): void => {
  useEffect(() => {
    const videos = [
      ...PROOF_STEPS.map(p => p.video),
      ...PROOF_STEPS.flatMap(p => p.subShots?.map(s => s.video) ?? []),
      ANCHOR_FAIL.video,
    ].filter(
      (v): v is NonNullable<typeof v> => v !== undefined,
    )
    const imageUrls = [
      ...PROOF_STEPS.map(p => p.basePhoto),
      ANCHOR_FAIL.photo,
      ...videos.map(v => v.poster),
    ]
    for (const url of imageUrls) {
      const img = new Image()
      img.src = url
    }
    for (const v of videos) {
      const el = document.createElement('video')
      el.preload = 'auto'
      el.muted = true
      el.src = v.src
    }
  }, [])
}
